module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_23.a2f3168c.png";